import moment from "moment";

export function formataData(data) {
  if (!data) return '';
  return moment(data, "YYYY-MM-DD").format("DD/MM/YYYY");
}

export function dataHoraAgora(hora = null) {
  const dataAtual = moment(new Date(), "DD/MM/YYYY");
  if (hora) {
    const [horas, minutos, segundos] = hora.split(':');
    dataAtual.set({
      hour: parseInt(horas, 10),
      minute: parseInt(minutos, 10),
      second: parseInt(segundos, 10),
    });
  }
  return dataAtual.format("YYYY-MM-DDTHH:mm:ss");
}

export function alteraHoraData(data, hora) {
  data = moment(data)
    .set({
      hour: parseInt(hora.split(":")[0], 10),
      minute: parseInt(hora.split(":")[1], 10),
      second: parseInt(hora.split(":")[2], 10),
    })
    .toISOString();

  return data;
}

export function formataDataJson(data) {
  if (!data) return '';
  return moment(data, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DDTHH:mm:ss");
}

export function formataDataHora(data) {
  if (!data) return '';
  return moment(data, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm:ss");
}

export function verificaDataVal(dataval) {
  let dtReal = moment(dataval);
  let dataAgora = moment();
  return dtReal > dataAgora;
}

export function timeAgo(dateTimeString) {
  const date = new Date(dateTimeString);
  const now = new Date();
  const diff = now - date;

  if (diff < 0) {
    return ''; // data no futuro
  }

  const secondsMs = 1000;
  const minuteMs = 60 * secondsMs;
  const hourMs = 60 * minuteMs;
  const dayMs = 24 * hourMs;
  const weekMs = 7 * dayMs;
  const monthMs = 30 * dayMs;

  if (diff <= 20 * secondsMs) {
    return 'agora mesmo';
  }

  if (diff <= 60 * secondsMs) {
    return 'a alguns segundos';
  }

  if (diff < minuteMs) {
    const secs = Math.floor(diff / secondsMs);
    return `há ${secs} segundo${secs > 1 ? 's' : ''}`;
  }

  if (diff < hourMs) {
    const mins = Math.floor(diff / minuteMs);
    return `há ${mins} minuto${mins > 1 ? 's' : ''}`;
  }

  if (diff < dayMs) {
    const hrs = Math.floor(diff / hourMs);
    const mins = Math.floor((diff % hourMs) / minuteMs);
    let out = `há ${hrs} hora${hrs > 1 ? 's' : ''}`;
    if (mins > 0) {
      out += ` e ${mins} minuto${mins > 1 ? 's' : ''}`;
    }
    return out;
  }

  if (diff < weekMs) {
    const days = Math.floor(diff / dayMs);
    return `há ${days} dia${days > 1 ? 's' : ''}`;
  }

  if (diff < monthMs) {
    const weeks = Math.floor(diff / weekMs);
    return `há ${weeks} semana${weeks > 1 ? 's' : ''}`;
  }

  if (diff < 2 * monthMs) {
    return 'há 1 mês';
  }

  return dateTimeString;
}
